import React from 'react';
import type { NewsItem } from '../content/siteContent';
import { formatNewsBadge, formatNewsDate } from '../utils/news';
import { renderInlineMarkdown } from '../lib/inlineMarkdown';
import MediaImage from './MediaImage';

type NewsCardProps = {
  item: NewsItem;
  priority?: boolean;
};

export default function NewsCard({ item, priority = false }: NewsCardProps) {
  const badge = formatNewsBadge(item.date);
  const image = item.image || '/brand/action-game/home-activity.webp';

  return (
    <article className="w-full relative group h-full">
      <div className="absolute -top-6 -left-6 lg:-left-8 w-24 h-24 rounded-full bg-yellow-400 shadow-xl flex flex-col justify-center items-center text-[#1a1b24] font-black z-20 border-4 border-yellow-400 group-hover:scale-110 transition-transform duration-300">
        <span className="text-3xl leading-none">{badge.day}</span>
        <span className="text-base uppercase tracking-widest mt-1">{badge.month}</span>
      </div>

      <div className="bg-white rounded-3xl overflow-hidden shadow-xl transform group-hover:-translate-y-2 transition-all duration-300 h-full flex flex-col">
        <div className="relative h-48 sm:h-56 overflow-hidden bg-[#1a1b24]">
          <MediaImage
            src={image}
            alt={`Actualités Gameside Caen - ${item.title}`}
            className="w-full h-full object-cover opacity-90 group-hover:scale-105 transition-transform duration-500"
            priority={priority}
            sizes="(min-width: 1280px) 400px, (min-width: 768px) 50vw, 100vw"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#1a1b24]/80 via-[#1a1b24]/10 to-transparent" />
          {item.tag && (
            <div className="absolute top-4 left-10 bg-[#a4d233] text-[#1a1b24] text-xs font-black uppercase px-3 py-1 rounded shadow-md transform -skew-x-6">
              {item.tag}
            </div>
          )}
          <p className="absolute bottom-4 left-6 right-6 text-white text-xs font-black uppercase tracking-[0.2em] drop-shadow">
            {formatNewsDate(item.date)}
          </p>
        </div>
        <div className="p-6 flex-grow flex flex-col justify-center items-center text-center">
          <h3 className="text-[#1a1b24] font-black text-xl mb-3 uppercase tracking-wide leading-tight">{item.title}</h3>
          <p className="text-gray-600 text-sm font-semibold leading-relaxed">
            {renderInlineMarkdown(item.excerpt, { linkClassName: 'underline decoration-yellow-400 hover:text-[#1a1b24] transition-colors' })}
          </p>
        </div>
      </div>
    </article>
  );
}
